// Iniciais (até 2 letras) a partir do nome completo — usado em avatares.
export function iniciais(nome = '') {
  const partes = nome.trim().split(/\s+/);
  return ((partes[0]?.[0] || '') + (partes[1]?.[0] || '')).toUpperCase();
}
